import { reportEvent } from '../sensor';

type MiniappWebviewRoute = 'editing-embed' | 'mini-live';

const reportedRoutes = new Set<MiniappWebviewRoute>();

/** Reports when a miniapp WebView page has successfully parsed its bootstrap parameters. */
export const reportMiniappWebviewBootstrapParsed = (route: MiniappWebviewRoute): void => {
  if (reportedRoutes.has(route)) return;

  reportedRoutes.add(route);
  reportEvent('miniapp_webview_bootstrap_parsed', {
    route,
    navigation_to_bootstrap_parsed_ms: Math.round(performance.now()),
  });
};
